import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const Spinner = ({ color = 'white' }) => {
  return (
    <div className="container">
      <FontAwesomeIcon icon={faSpinner} spin size="10x" color={color}></FontAwesomeIcon>
    </div>
  );
};
export default Spinner;
